import { render, staticRenderFns } from "./materialUnit.vue?vue&type=template&id=9c825586&scoped=true"
import script from "./materialUnit.vue?vue&type=script&lang=js"
export * from "./materialUnit.vue?vue&type=script&lang=js"
import style0 from "./materialUnit.vue?vue&type=style&index=0&id=9c825586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c825586",
  null
  
)

export default component.exports